import { useEffect, useState } from "react";
import Notification, { handleMessageSuccess, handleMessageWarning } from "../../../../components/toast";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { schema, schemaDefaultValues } from "./schema";
import LibBoolean from "../../../../util/libBool";
import { id } from "date-fns/locale";

export const IndexHook = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	// setLoading,
	fetchID,
	reloadData,
	insert,
}) => {
	const {
		register,
		handleSubmit,
		setValue,
		setFocus,
		// setError,
		watch,
		reset,
		control,
		formState: { errors, isSubmitting },
	} = useForm({
		mode: "onSubmit",
		//quando revalidar os campos
		resolver: zodResolver(schema),
		defaultValues: schemaDefaultValues,
	});

	const [loading, setLoading] = useState(false);

	const handleCloseModalRegister = () => {
		const event = new CustomEvent(`${ident}`);
		window.dispatchEvent(event);
	};

	const id_instagram = watch("id_instagram");
	const descricao = watch("descricao");
	//#region Fetch
	useEffect(() => {
		if (isOpenModalRegister) {
			const id =
				typeof selectedData[idTable] === "number" && !isNaN(selectedData[idTable]) ? selectedData[idTable] : 0;

			if (id > 0) {
				fetch(id);
			}
		} else {
			if (setSelectData) setSelectData({});

			reset();
		}
	}, [isOpenModalRegister, selectedData]);

	const fetch = async (id) => {
		try {
			setLoading(true);

			const response = await fetchID(id);

			if (response.data && typeof response.data === "object") {
				const data = response.data;

				const newData = await processNewData(data);

				Object.keys(newData).forEach((field) => {
					setValue(field, newData[field]);
				});
			}
		} catch (error) {
			Notification.showToast({
				message: error.message,
				type: "warning",
			});
		} finally {
			setLoading(false);
		}
	};

	const processNewData = async (data) => {
		return {
			...data,
			ativo: LibBoolean.strToBoolean(data.ativo),
		};
	};

	//#endregion

	const getReturnUpdated = (response) => {
		if (Array.isArray(response.data)) {
			return response.data[0];
		} else if (typeof response.data === "object") {
			return response.data;
		} else {
			throw new Error("Formato do retorno inválido.");
		}
	};

	//#region onSubmit
	const handleOnSubmit = async (data) => {
		try {
			const newDate = ValidateSubmit(data);

			let response;
			const oldID = data[idTable];

			response = await insert(newDate);

			const returnUpdated = getReturnUpdated(response);

			const currentId = returnUpdated[idTable];

			await reloadData(oldID, currentId);

			handleMessageSuccess("Registro salvo com sucesso.");
			fetch(currentId);
			// reset();
			// handleCloseModalRegister();
		} catch (error) {
			if (error.field && error.field !== "ID_FORMA") {
				// errosAfterPost(error.field, error.message);
			}
			handleMessageWarning("Não foi possível salvar, " + error.message);
		}
	};

	const ValidateSubmit = (data) => {
		const newAtivo = LibBoolean.booleanToStr(data.ativo);

		const newData = {
			...data,
			ativo: newAtivo,
		};

		return newData;
	};

	//#endregion
	return {
		//hooks
		handleOnSubmit,
		handleCloseModalRegister,

		//useForm
		register,
		handleSubmit,
		setValue,
		control,
		setFocus,
		loading,

		id_instagram,
		descricao,

		//formState
		errors,
		isSubmitting,
	};
};
